/* talk·point — Produkte im Ratgeber (snippets/tp-article-shop.liquid, blocks/_blog-post-content.liquid).
   Alles ohne JS verzichtbar (Rails + Desktop-Leiste stehen server-seitig im HTML):
   1. Tabs: weitere Collections liegen als <template> im Track und werden beim Klick getauscht.
   2. Inhaltsverzeichnis aus den <h2> — links auf dem Desktop, im Sheet auf dem Handy.
   3. Desktop: Seitenleiste ausblenden, solange eine Rail durch die Bildschirmmitte läuft.
   4. Unter 1200 px: Leiste unten ab dem ersten Bild, öffnet Inhalt/Produkte als Sheet.
   5. Klicks an TP.track melden. */
(function () {
  if (window.__tpArticleShop) return;
  window.__tpArticleShop = true;

  // ── 1. Tabs ──
  function bindTabs(root, panels) {
    const track = root.querySelector('.tpas__track');
    const tabs = [...root.querySelectorAll('[data-tpas-tab]')];
    for (const tab of tabs) {
      tab.addEventListener('click', () => {
        if (tab.getAttribute('aria-selected') === 'true') return;
        track.innerHTML = panels[Number(tab.dataset.tpasTab)];
        track.scrollLeft = 0;
        track.scrollTop = 0;
        tabs.forEach((t) => t.setAttribute('aria-selected', String(t === tab)));
      });
    }
  }

  let sheetPanels = null;
  for (const rail of document.querySelectorAll('.tpas')) {
    const track = rail.querySelector('.tpas__track');
    if (!track) continue;
    const tpls = [...track.querySelectorAll('template[data-tpas-panel]')];
    const panels = tpls.map((t) => t.innerHTML);
    tpls.forEach((t) => t.remove());
    panels.unshift(track.innerHTML);
    if (!sheetPanels) sheetPanels = { panels, tabs: rail.querySelector('.tpas__tabs') };
    bindTabs(rail, panels);
  }

  // ── 2. Inhaltsverzeichnis ──
  const heads = [...document.querySelectorAll('.tpas-main .blog-post-content h2')];
  const tocDesk = document.querySelector('.tpas-toc');
  const tocSheet = document.querySelector('[data-tpas-toc-sheet]');
  const tocLinks = [];
  if (heads.length >= 3) {
    const slug = (s) => s.toLowerCase().normalize('NFD').replace(/\p{M}/gu, '')
      .replace(/ß/g, 'ss').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
    heads.forEach((h) => { if (!h.id) h.id = slug(h.textContent) || 'abschnitt'; });
    const list = () => heads.map((h) => {
      const a = document.createElement('a');
      a.href = '#' + h.id;
      a.textContent = h.textContent.trim();
      tocLinks.push(a);
      return a;
    });
    if (tocDesk) {
      const title = document.createElement('p');
      title.className = 'tpas-toc__h';
      title.textContent = 'Inhalt';
      const nav = document.createElement('nav');
      nav.append(...list());
      tocDesk.append(title, nav);
      tocDesk.hidden = false;
    }
    if (tocSheet) tocSheet.append(...list());

    // Aktiv = letzte Überschrift, die das obere Drittel schon passiert hat.
    const io = new IntersectionObserver(() => {
      let cur = 0;
      heads.forEach((h, i) => { if (h.getBoundingClientRect().top < window.innerHeight / 3) cur = i; });
      tocLinks.forEach((a) => a.setAttribute('aria-current', String(a.hash === '#' + heads[cur].id)));
    }, { rootMargin: '0px 0px -66% 0px' });
    heads.forEach((h) => io.observe(h));

    // Sprung unter den klebenden Header: mobil ist .tp-header 139 px hoch, ein reiner
    // Anker-Sprung landete die Überschrift dahinter.
    document.addEventListener('click', (e) => {
      const a = e.target.closest('.tpas-toc a, [data-tpas-toc-sheet] a');
      if (!a) return;
      const h = document.getElementById(a.hash.slice(1));
      if (!h) return;
      e.preventDefault();
      a.closest('dialog')?.close();
      const header = document.querySelector('.tp-header');
      const hb = header ? header.getBoundingClientRect().bottom : 0;
      h.style.scrollMarginTop = Math.max(0, hb) + 16 + 'px';
      h.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      history.replaceState(null, '', a.hash);
    });
  }

  // ── 3. Desktop-Seitenleiste stummschalten ──
  const side = document.querySelector('.tpas-side');
  const slots = [...document.querySelectorAll('.tpas-slot')];
  if (side && slots.length) {
    const visible = new Set();
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => (e.isIntersecting ? visible.add(e.target) : visible.delete(e.target)));
      side.classList.toggle('is-muted', visible.size > 0);
    }, { rootMargin: '-40% 0px -40% 0px' }); // nur das mittlere Fünftel zählt — sonst blendete schon 1 px Rail-Kante am Rand die Leiste aus
    slots.forEach((s) => io.observe(s));
  }

  // ── 4. Mobile Leiste + Sheets ──
  const bar = document.querySelector('[data-tpas-bar]');
  const sheetShop = document.querySelector('[data-tpas-sheet="shop"]');
  const sheetToc = document.querySelector('[data-tpas-sheet="toc"]');
  if (bar && sheetShop && typeof sheetShop.showModal === 'function' && sheetPanels) {
    // An <body>: .tp-blogpost-content bildet mit z-index:1 einen Stacking-Kontext.
    document.body.append(bar, sheetShop, sheetToc);

    // Mini-Bilder aus der Desktop-Leiste (160 px, dort unsichtbar und noch nicht geladen).
    const thumbs = bar.querySelector('.tpas-bar__thumbs');
    document.querySelectorAll('.tpas-row__ph img').forEach((img, i) => {
      if (i > 2) return;
      const t = document.createElement('img');
      t.src = img.getAttribute('src');
      t.alt = '';
      t.width = t.height = 26;
      thumbs.append(t);
    });

    const tocBtn = bar.querySelector('[data-tpas-open="toc"]');
    if (tocLinks.length) tocBtn.hidden = false;
    bar.hidden = false;

    // Sichtbar ab dem ersten Bild. Kurz weg, solange eine Rail durch die Bildschirmmitte läuft
    // (dieselben Produkte stünden sonst doppelt da, Regel wie die Desktop-Seitenleiste), und
    // ab dem Artikelende, damit Footer und Pflichtlinks (Impressum, AGB) frei bleiben.
    // Scroll-Listener statt IntersectionObserver: ein Sprung in einem Zug über eine Rail hinweg
    // (Anker, Inhalt-Sprung, Scroll-Wiederherstellung nach Reload) meldet der Observer nicht.
    // capture: auf document, weil ab 990 px .page-wrapper scrollt und scroll nicht aufsteigt.
    const layout = document.querySelector('.tpas-layout');
    let raf = 0;
    const update = () => {
      raf = 0;
      const vh = window.innerHeight;
      const railInMid = slots.some((s) => {
        const r = s.getBoundingClientRect();
        return r.top < vh * 0.6 && r.bottom > vh * 0.4;
      });
      const pastEnd = layout ? layout.getBoundingClientRect().bottom < vh : false;
      bar.classList.toggle('is-shown', !railInMid && !pastEnd && !document.querySelector('.tpas-sheet[open]'));
    };
    const schedule = () => { if (!raf) raf = requestAnimationFrame(update); };
    document.addEventListener('scroll', schedule, { passive: true, capture: true });
    window.addEventListener('resize', schedule, { passive: true });
    update();

    let filled = false;
    const open = (sheet) => {
      if (sheet === sheetShop && !filled) {
        filled = true;
        const body = sheetShop.querySelector('[data-tpas-sheet-body]');
        if (sheetPanels.tabs) {
          const tabs = sheetPanels.tabs.cloneNode(true);
          tabs.querySelectorAll('[data-tpas-tab]').forEach((t, i) => t.setAttribute('aria-selected', String(i === 0)));
          body.append(tabs);
        }
        const track = document.createElement('div');
        track.className = 'tpas__track';
        track.innerHTML = sheetPanels.panels[0];
        body.append(track);
        bindTabs(body, sheetPanels.panels);
      }
      sheet.showModal();
      schedule();
    };
    bar.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-tpas-open]');
      if (btn) open(btn.dataset.tpasOpen === 'toc' ? sheetToc : sheetShop);
    });
    for (const sheet of [sheetShop, sheetToc]) {
      sheet.addEventListener('click', (e) => {
        // Klick auf den Hintergrund (das <dialog> selbst) oder das X schließt.
        if (e.target === sheet || e.target.closest('[data-tpas-close]')) sheet.close();
      });
      sheet.addEventListener('close', schedule);
    }
  }

  // ── 5. Tracking ──
  // Bestehender Event-Typ statt neuem: das storefronthub-Backend whitelistet Typen (tp-track.js).
  // Artikel steckt schon in event.url, der Platz in props.slot (top/end/side/sheet).
  document.addEventListener('click', (e) => {
    const a = e.target.closest('[data-tpas-slot] a[href]');
    if (!a || !window.TP) return;
    const slot = a.closest('[data-tpas-slot]').dataset.tpasSlot;
    const path = new URL(a.href, location.href).pathname;
    try {
      window.TP.track('collection_clicked', {
        source: 'ratgeber',
        slot,
        kind: path.startsWith('/products/') ? 'product' : 'collection',
        target: path.split('/').pop(),
      });
    } catch (err) {}
  });
})();
